import {useMemo} from 'react'
import {useLocation, matchPath} from 'react-router-dom'
import {PolicyRoutesEnum} from 'interfaces'

const routesToMatch = [PolicyRoutesEnum.POLICIES_CONTENT, PolicyRoutesEnum.DLP]
/**
 * Custom hook to determine if the common footer should be displayed
 * based on the current pathname
 */
export const useCommonFooter = (): boolean => {
  const {pathname} = useLocation()

  const isCommonFooterUsed = useMemo(() => {
    return routesToMatch.some(route =>
      matchPath(pathname, {
        path: route,
        exact: true,
        strict: false,
      }),
    )
  }, [pathname])

  return isCommonFooterUsed
}
